class FankaLpFullPage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.scopeInlineStyles();
  }

  scopeInlineStyles() {
    const content = this.querySelector('[data-fanka-lp-content]');
    if (!(content instanceof HTMLElement)) return;

    content.querySelectorAll('style:not([data-fanka-lp-scoped])').forEach((styleElement) => {
      styleElement.textContent = styleElement.textContent.replace(
        /(-?\d*\.?\d+)rem/g,
        (_, value) => `${Number(value) * 0.625}rem`
      );
      styleElement.dataset.fankaLpScoped = 'true';

      try {
        this.scopeRuleList(styleElement.sheet?.cssRules);
      } catch (error) {
        // 个别旧样式无法通过 CSSOM 修改时保持原规则，避免阻断页面其余逻辑。
      }
    });
  }

  scopeRuleList(rules) {
    if (!rules) return;

    Array.from(rules).forEach((rule) => {
      if (rule instanceof CSSStyleRule) {
        try {
          rule.selectorText = rule.selectorText
            .split(',')
            .map((selector) => this.scopeSelector(selector))
            .join(', ');
        } catch (error) {
          // 保留浏览器无法重写的单条旧选择器，并继续处理同一 style 内的其他规则。
        }
        return;
      }

      if ('cssRules' in rule && !(rule instanceof CSSKeyframesRule)) {
        this.scopeRuleList(rule.cssRules);
      }
    });
  }

  scopeSelector(selector) {
    const scope = '[data-fanka-lp-content]';
    let scopedSelector = selector.trim();

    if (scopedSelector.includes(scope)) return scopedSelector;

    scopedSelector = scopedSelector.replace(/:root|\bhtml\b|\bbody\b/g, scope);
    while (scopedSelector.includes(`${scope} ${scope}`)) {
      scopedSelector = scopedSelector.replace(`${scope} ${scope}`, scope);
    }

    return scopedSelector.includes(scope) ? scopedSelector : `${scope} ${scopedSelector}`;
  }
}

class FankaLpProductTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab, index) => {
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.addEventListener('click', () => this.selectTab(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.setMobileListWidths();
    window.addEventListener('resize', () => this.setMobileListWidths(), { passive: true });
  }

  selectTab(index) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.classList.toggle('active', active);
      panel.hidden = !active;
    });

    this.setMobileListWidths();
  }

  onKeydown(event, index) {
    let nextIndex = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = this.tabs.length - 1;
    else return;

    event.preventDefault();
    this.selectTab(nextIndex);
    this.tabs[nextIndex].focus();
  }

  setMobileListWidths() {
    this.panels.forEach((panel) => {
      const list = panel.querySelector('.more_list');
      if (!(list instanceof HTMLElement)) return;

      if (window.innerWidth < 768) {
        list.style.width = `${66 * list.querySelectorAll('.list_item').length}vw`;
      } else {
        list.style.removeProperty('width');
      }
    });
  }
}

if (!customElements.get('fanka-lp-full-page')) {
  customElements.define('fanka-lp-full-page', FankaLpFullPage);
}

if (!customElements.get('fanka-lp-product-tabs')) {
  customElements.define('fanka-lp-product-tabs', FankaLpProductTabs);
}
